import React, { useState, useEffect, useRef } from "react";
import TextField from "@mui/material/TextField";
import "./classes/PayOrder.css";
import "./classes/Main.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faShoppingBasket } from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";
import { useReactToPrint } from "react-to-print";
import { configData } from "../config";

const PayOrder = () => {
  // const products = [
  //   { id: 1, name: "turmeric powder", price: 5, barcode: "10001", stock: 150 },
  //   { id: 2, name: "amla juice", price: 6, barcode: "10002", stock: 84 },
  //   { id: 3, name: "mixed fruits", price: 7, barcode: "10003", stock: 100 },
  //   { id: 4, name: "bath soap", price: 8, barcode: "10004", stock: 120 },
  //   { id: 5, name: "toothpaste", price: 4, barcode: "10005", stock: 180 }
  // ];

  /* ---------------- STATE ---------------- */
  const API_BASE = configData.APP_URL;
  const [searchValue, setSearchValue] = useState("");
  const [barcodeValue, setBarcodeValue] = useState("");
  const [cart, setCart] = useState([]);
  const [cashPaid, setCashPaid] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [customerType, setCustomerType] = useState("retail"); 
  const [paymentType, setPaymentType] = useState("cash"); // could be "cash" or "card"
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  
const fetchItems = async () => {
  try {
    setLoading(true);
    const res = await fetch(`${API_BASE}items/lists`);
    const data = await res.json();

    let list = [];
    if (Array.isArray(data)) {
      list = data;
    } else if (data?.data && Array.isArray(data.data)) {
      list = data.data;
    } else if (data?.items && Array.isArray(data.items)) {
      list = data.items;
    }

    //  NORMALIZE BACKEND FIELDS
    const normalized = list.map(item => ({
      id: item.id,
      name: item.item_name,
      barcode: item.barcode,
      retail: item.retail_price ?? item.retail ?? 0,
      wholesale: item.wholesale_price ?? item.wholesale ?? 0,
      stock: item.stock ?? item.quantity_stock ?? 0
    }));

    setItems(normalized);
  } catch (error) {
    console.error("Error fetching items:", error);
    setItems([]);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchItems();
  }, []);


//   const componentRef = useRef(null);
//   const handlePrint = useReactToPrint({
//     content: () => componentRef.current,
//     documentTitle: "Receipt"
//   });
    const contentRef = useRef(null);
//   const reactToPrintFn = useReactToPrint({
//     content: () => contentRef.current,
//   });

  const handlePrint = useReactToPrint({
    contentRef: contentRef,
    documentTitle: "Receipt",
  });

  /* ---------------- PRODUCT FILTER (NAME ONLY) ---------------- */
const filteredItems = items.filter(item =>
  item.name?.toLowerCase().includes(searchValue.toLowerCase())
);
  /* ---------------- BARCODE SCAN (ONLY ADD TO CART) ---------------- */
useEffect(() => {
  if (!barcodeValue) return;

  if (/^\d+$/.test(barcodeValue)) {
    const item = items.find(i => i.barcode === barcodeValue);
    if (item) {
      addToCart(item);
      setBarcodeValue("");
    }
  }
}, [barcodeValue, items]);

  /* ---------------- ADD TO CART ---------------- */
const addToCart = product => {
  const price = customerType === "retail" ? product.retail : product.wholesale;

  setCart(prev => {
    const found = prev.find(p => p.id === product.id);
    if (found) {
      return prev.map(p =>
        p.id === product.id
          ? { ...p, qty: p.qty + 1, total: (p.qty + 1) * price, price }
          : p
      );
    }
    return [...prev, { ...product, qty: 1, total: price, price }];
  });
};

  /* ---------------- REMOVE ITEM ---------------- */
  const removeItem = id => {
    setCart(prev => prev.filter(p => p.id !== id));
  };

  /* ---------------- TOTALS ---------------- */
  const total = cart.reduce((s, i) => s + i.total, 0);
  const change =
    cashPaid >= total ? (cashPaid - total).toFixed(2) : "0.00";

  /* ---------------- ACTIONS ---------------- */
  const handleCancel = () => {
    setSearchValue("");
    setBarcodeValue("");
    setCart([]);
    setCashPaid(0);
  };

  const handleNewSale = () => {
    setCart([]);
    setCashPaid(0);
    setIsModalOpen(false);
  };
 const handleSubmit = async () => {
  if (isSubmitting) return;
  if (cart.length === 0) {
    alert("Add at least one product");
    return;
  }

  const cash = parseFloat(cashPaid) || 0;
  if (paymentType === "cash" && cash < total) {
    alert(`Cash received (₹${cash.toFixed(2)}) is less than total (₹${total.toFixed(2)}). Please enter the correct amount.`);
    return;
  }

  setIsSubmitting(true);

  const payload = {
    total_amount: total,
    customer_type: customerType,
    payment_type: paymentType,
    cash_received: paymentType === "cash" ? cash : 0,
    change_amount: paymentType === "cash" ? (cash - total) : 0,
    items: cart.map(item => ({
      item_id: item.id,
      item_name: item.name,
      barcode: item.barcode,
      quantity: String(item.qty),
      price: item.price,
      total: item.total
    }))
  };

  console.log("Payload to submit:", payload);

  try {
    const res = await fetch(`${configData.APP_URL}sales/sales-items`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

    const data = await res.json();

    if (data.success) {
      alert("Order saved successfully");
      setCart([]);
      setCashPaid(0);
      setIsModalOpen(false);
      // Optionally refresh invoice number or fetch latest data
    } else {
      alert("Failed to save order");
    }
  } catch (err) {
    console.error(err);
    alert("Error submitting order");
  } finally {
    setIsSubmitting(false);
  }
};

  return (
    <div className="pos-main">
      <Helmet>
        <title>Pay Order</title>
      </Helmet>

      <div className="pos-body">
        {/* LEFT PANEL */}
        <div className="pos-left">
            <div className="pos-flex">
              <div className="customer-type-selector">
                  <label>
                    Customer Type:
                    <select
                      value={customerType}
                      onChange={(e) => setCustomerType(e.target.value)}
                    >
                      <option value="retail">Retail</option>
                      <option value="wholesale">Wholesale</option>
                    </select>
                  </label>
                </div>
                <TextField
                    value={searchValue}
                    onChange={e => setSearchValue(e.target.value)}
                    placeholder="Search product"
                    fullWidth
                    className="pos-flex-1"
                />

                <input
                    className="barcode-input pos-flex-2"
                    value={barcodeValue}
                    onChange={e => setBarcodeValue(e.target.value)}
                    autoFocus
                    placeholder="Scan barcode"
                />
            </div>
       <div className="product-grid">
          {loading && <p>Loading products...</p>}
          {error && <p style={{color:"red"}}>{error}</p>}

       {!loading && filteredItems.map(item => (
          <div
            key={item.id}
            className="product-card"
            onClick={() => addToCart(item)}
          >
            <h4>{item.name}</h4>
            <small>{item.barcode}</small>
           <div className="product-footer">
            <span>Stock: {item.stock}</span>
            <span>
              ₹{customerType === "retail" ? item.retail.toFixed(2) : item.wholesale.toFixed(2)}
            </span>
          </div>
          </div>
        ))}
        </div>
        </div>

        {/* RIGHT PANEL */}
        <div className="pos-right">
            <div className="pos-right-heading">
                <div>
                    <FontAwesomeIcon className="pos-right-heading-icon" icon={faShoppingBasket} /><h3>Current Order</h3>
                </div>
                <span onClick={handleCancel} style={{color: "red", lineHeight: "3.6", marginRight:"5px"}}>CLEAR</span>
            </div>

          {cart.length === 0 ? (
            <p className="empty-cart">Start scanning...</p>
          ) : (
            cart.map(item => (
              <div className="order-item" key={item.id}>
                <div>
                  {item.name} × {item.qty}
                </div>
                <div>
                <span>
                  ₹{item.total}
                  </span>&nbsp;&nbsp;
                  <span style={{marginRight:"5px"}}>
                  <FontAwesomeIcon
                    icon={faTrash}
                    className="delete"
                    onClick={() => removeItem(item.id)}
                  />
                  </span>
                </div>
              </div>
            ))
          )}

          <div className="payment">
            <h2>Total: ₹{total.toFixed(2)}</h2>

            <input
              className="cash-input"
              value={cashPaid}
              onChange={e => setCashPaid(Number(e.target.value) || 0)}
              placeholder="Cash given"
            />

            <div className="quick-cash">
              <button onClick={() => setCashPaid(5)}>€5</button>
              <button onClick={() => setCashPaid(10)}>€10</button>
              <button onClick={() => setCashPaid(20)}>€20</button>
              <button onClick={() => setCashPaid(50)}>€50</button>
            </div>

            <h4>Change: €{change}</h4>

            <div className="actions">
              <button className="cancel" 
              style={{cursor:"pointer"}}
              onClick={handleCancel}>
                Cancel
              </button>
              <button
                className="pay"
                style={{cursor:"pointer"}}
               // disabled={cart.length === 0}
                // onClick={() => {
                //     if (cashPaid < total) {
                //         alert("Low amount");
                //         return;
                //     }
                //     setIsModalOpen(true)}}
                onClick={handleSubmit}
                >
                PAY NOW
              </button>
            </div>
          </div>
        </div>
      </div>

      
  {isModalOpen && (
  <div className="modal-overlay">
    <div className="modal-box">
      <div className="success-icon">✓</div>

      <h2>Payment Successful!</h2>

      <div className="summary">
        <div>
          <span>Total:</span>
          <span>€{total.toFixed(2)}</span>
        </div>
        <div>
          <span>Paid:</span>
          <span>€{cashPaid.toFixed(2)}</span>
        </div>
        <div className="change">
          <span>CHANGE</span>
          <span>€{change}</span>
        </div>
      </div>

      <div className="modal-actions">
        <button className="dark" onClick={handlePrint}>
          Print Receipt
        </button>
        <button className="primary" onClick={handleNewSale}>
          New Sale
        </button>
      </div>
    </div>
  </div>
)}
<div ref={contentRef} className="printContent">
  <div className="receipt">
    <h2 className="shop-name">MY SHOP</h2>

    <div className="meta">
      <div>Date: {new Date().toLocaleString()}</div>
      <div>No: {Date.now()}</div>
    </div>

    <hr />

    <table className="items">
      <thead>
        <tr>
          <th>Qty</th>
          <th>Item</th>
          <th className="right">Price</th>
        </tr>
      </thead>
      <tbody>
        {cart.map(item => (
          <tr key={item.id}>
            <td>{item.qty}</td>
            <td>{item.name}</td>
            <td className="right">€{item.total.toFixed(2)}</td>
          </tr>
        ))}
      </tbody>
    </table>

    <hr />

    <div className="totals">
      {/* <div><span>Net:</span><span>€{(total - 2.9).toFixed(2)}</span></div>
      <div><span>GST:</span><span>€2.90</span></div> */}
      <div className="bold"><span>TOTAL:</span><span>€{total.toFixed(2)}</span></div>
      <div><span>CASH:</span><span>€{cashPaid.toFixed(2)}</span></div>
      <div><span>CHANGE:</span><span>€{change}</span></div>
    </div>

    <p className="thanks">*** THANK YOU ***</p>
  </div>
</div>


    </div>
  );
};

export default PayOrder;